<template>
    <!-- 分支机构 -->
    <div>
        <pageNav :currentActiveNav="'分支机构'" v-if="isMobile"></pageNav>
        <pageHeader></pageHeader>
        <div class="content">
            <pageNav :currentActiveNav="'分支机构'" v-if="!isMobile"></pageNav>
            <div class="content-title">{{ config.contentTitle }}</div>
            <div class="content-desc">{{ config.contentDesc }}</div>
            <div class="content-address">
                <el-image class="address-item-img" :src="config.contentImg" lazy fit="cover"></el-image>
            </div>
            <div class="system-content">
                <div v-for="(system, systemIndex) in config.contentMore" :key="systemIndex" class="system-item">
                    <div class="system-item-title">{{ system.title }}</div>
                    <div class="system-item-info">{{ system.info }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { config } from "./js/branch";
import pageHeader from "./components/header.vue";
import pageNav from "./components/navMenu.vue";
export default {
    name: "",
    components: { pageHeader, pageNav },
    data() {
        return {
            config: config,
        };
    },
    watch: {},
    computed: {
        isMobile() {
            return this.$store.getters.isMobile;
        }
    },
    mounted() { },
    methods: {

    },
};
</script>

<style scoped lang="less">
.content {
    padding: 45px 68px 150px;

    .content-title {
        font-size: @fontSize40;
        margin-bottom: 40px;
    }

    .content-desc {
        font-size: @fontSize20;
        margin-bottom: 60px;
    }

    .content-address {
        .address-item-img {
            width: 100%;
            height: 100%;
        }
    }

    .system-content {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-column-gap: 24px;
        margin-top: 100px;

        .system-item {
            padding: 30px 0px 0px;
            border-top: 1px solid @mainGrayColor3;

            &:nth-last-child(2),
            &:last-child {
                border-bottom: 1px solid @mainGrayColor3;
            }

            .system-item-title {
                font-size: 40px;
                position: relative;
                width: fit-content;
                cursor: pointer;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
            }

            .system-item-info {
                font-size: 20px;
                line-height: 32px;
                margin: 20px 0 51px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
                overflow: hidden;
            }
        }
    }
}

@media @mobile {
    .content {
        padding: 20px 16px 60px;

        .content-title {
            font-size: 24px;
            margin-bottom: 20px;
            line-height: 1.3;
        }

        .content-desc {
            font-size: 16px;
            margin-bottom: 30px;
            line-height: 1.5;
        }

        .content-address {
            .address-item-img {
                width: 100%;
                height: auto;
                object-fit: cover;
            }
        }

        .system-content {
            grid-template-columns: 1fr;
            grid-column-gap: 0;
            grid-row-gap: 20px;
            margin-top: 40px;

            .system-item {
                padding: 20px 0 0;

                &:nth-last-child(2),
                &:last-child {
                    border-bottom: 1px solid @mainGrayColor3;
                }

                .system-item-title {
                    font-size: 24px;
                    line-height: 1.4;
                    -webkit-line-clamp: 2;
                    height: auto;
                }

                .system-item-info {
                    font-size: 16px;
                    line-height: 24px;
                    margin: 16px 0 30px;
                    -webkit-line-clamp: 3;
                }
            }
        }
    }
}
</style>